module.exports = __webpack_public_path__ + "media/images/input_state_icon/sync-87f42b412a37761c4819629845548850.svg";